import { useNavigate } from 'react-router-dom'
import { Home } from 'lucide-react'
import { Button } from '@/components/common/Button'
import { BrandMark } from '@/components/common/BrandMark'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-paper">
      <div className="container-page flex min-h-screen flex-col items-center justify-center text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-700 text-cream shadow-soft">
          <BrandMark size={30} />
        </div>
        <p className="mt-6 text-[10px] font-bold uppercase tracking-[0.18em] text-accent-600">
          404 — Page not found
        </p>
        <h1 className="mt-2 h-display text-4xl font-bold text-ink-900 sm:text-5xl">
          We couldn't find that page.
        </h1>
        <p className="mt-3 max-w-md text-pretty text-sm text-ink-500">
          The link may be broken, or the page may have been removed. Head back to the dashboard
          and we'll get you on your way.
        </p>
        <div className="mt-7">
          <Button
            onClick={() => navigate('/')}
            leftIcon={<Home className="h-4 w-4" />}
            size="lg"
          >
            Go to dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}
